// extracted by mini-css-extract-plugin
export var label = "_ax-5";
export var slideContainer = "_ax-0";
export var slider = "_ax-1";
export var sliderLg = "_ax-4";
export var sliderMd = "_ax-3";
export var sliderSm = "_ax-2";